import { RouteName, TextKey } from '@mews-commander/enums';
import { createAction, lt, showSuccessAlert } from '@mews/framework';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { navigateInModal } from '../../app/actions/common';
import { createDeleteAction } from '../../entityManagement';
import { SIDEBAR_CLOSED } from '../actionTypes';
import { isSidebarOpened } from '../selectors';
import { dispatchWithSidebarClosedTracking } from './analyticsTracking';
import { deleteRestrictions as deleteRestrictionsApi } from './api';
import { resetCellSelection } from './matrix';

export const closeSidebar =
    (serviceId: string): CommanderThunkAction =>
    (dispatch, getState) => {
        if (isSidebarOpened(getState(), { serviceId })) {
            dispatch(dispatchWithSidebarClosedTracking(createAction(SIDEBAR_CLOSED, null, { scope: serviceId })));
        }
        dispatch(resetCellSelection(serviceId));
    };

const restrictionDeleter = ({ id, serviceId }: { serviceId: string; id: string }) =>
    deleteRestrictionsApi({ serviceId, restrictionIds: [id] });
const restrictionDeleteAction = createDeleteAction(restrictionDeleter);

export const deleteRestriction =
    (ownerId: string, scope: string): CommanderThunkAction =>
    (dispatch) =>
        dispatch(restrictionDeleteAction({ serviceId: scope }, scope)).then(() => {
            showSuccessAlert({
                description: lt('DeleteSuccessMessage', { entity: TextKey.Restriction }),
            });
            dispatch(closeSidebar(scope));
            dispatch(resetCellSelection(scope));
        });

export const deleteRestrictionHeadingAction =
    ({ serviceId, id }: { serviceId: string; id: string }): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { resolveRoute }) =>
        // @ts-expect-error
        dispatch(restrictionDeleter({ serviceId, id })).then(() => {
            showSuccessAlert({
                description: lt('DeleteSuccessMessage', { entity: TextKey.Restriction }),
            });

            const url = resolveRoute(RouteName.RestrictionIndex, { query: { OwnerId: serviceId } });
            dispatch(navigateInModal(url));
        });
